//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapState, mapMutations } from "vuex";
import truncateString from '../../../util/truncateString'
import { VueEllipsis } from 'vue-ellipsis-component';

export default {
    name: 'ui-page-header',

    components: {
        VueEllipsis

    },

    filters: {

    },

    props: ['playersBetSum', 'playersCount', 'privateSeed', 'publicSeed'],

    data() {
        return {

        };
    },




    watch: {
    },
    computed: {
        ...mapState(["user"]),
    },
    created() {


    },
    mounted() {

    },


    beforeDestroy() {
    },

    methods: {

        ...mapMutations([""]),
        truncateString
    }
}

